import { render, staticRenderFns } from "./VGoogleMap.vue?vue&type=template&id=12fd0bfa"
import script from "./VGoogleMap.vue?vue&type=script&lang=js"
export * from "./VGoogleMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports